<template lang="pug">
    #companion-topic-main
      BLoading(v-if="dailyStrategyLoading" :active="dailyStrategyLoading" :is-full-page="true")
      .companion-topic-card(v-else)
        .companion-topic-content-wrapper
          .companion-topic-content
            .companion-action-menu
              CompanionActionsMenu(:backButton="goBack")
            .show-topic-details
              .green-card(:style="{ backgroundColor: backgroundColor }")
                .cover-art
                  img(:src="strategyHeroImage")
              .topic-details-card
                .topic-title Topic
                .topic-number-title {{ topicData.Title }}
                .topic-info-title
                  WtSvgIcon( icon="companion/journal" width="16px", height="16px" ).mt-1
                  span {{ topicData.NumberOfGuides }} guides
                .topic-part-summary(v-html="topicData.IntroText")
        .view-program-documents(v-if="havingDocumentUrl")
          .button-wrapper
            button(@click="redirectToDocument()" :class="{ 'blue-button': true }")
              .doc-button-text
                WtSvgIcon(icon="companion/article_white" width="16px" height="16px").mt-1
                span View Program
        .companion-related-guides
          .is-flex.is-flex-direction-column
              .column.is-12.custom-padding(v-if="havingRelatedGuides")
                  .category-title Expert guides
                  .guide-card-container(@mouseover="focusTasksContainer" tabindex="0" v-on="wheelListener")
                      CompanionGuideCard.guide-card(
                        v-for="(guide, index) in RelatedGuides"
                        :key="index"
                        :partNumber="guide.Number"
                        :previewImage="guide.PreviewImage"
                        :id="guide.GuideId"
                        :duration="guide.Duration"
                        :partTitle="guide.GuidePartTitle"
                        :partId="guide.GuidePartId"
                        :redirectTo="getGuideRedirectUrl(guide.GuidePartId)" )
        .companion-related-strategy
          .category-title Strategies for change
          .strategy-list
            div(v-for="(strategy, index) in RelatedTopics" :key="strategy.Id")
              .right-arrow-card
                CompanionRightArrowCard(:redirectTo="getStrategyRedirectUrl(strategy.Id)" :title="strategy.Title" )
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import CompanionTopicCard from "@@/Companion/CompanionTopicCard";
import CompanionGuideCard from "@@/Companion/CompanionGuideCard";
import CompanionRightArrowCard from "@@/Companion/CompanionRightArrowCard";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "CompanionTopic",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtSvgIcon,
    CompanionActionsMenu,
    CompanionTopicCard,
    CompanionGuideCard,
    CompanionRightArrowCard
  },
  data() {
    return {
      dailyStrategyLoading: false,
      topicData: {},
      backgroundColor: "#ffffff",
      strategyHeroImage: "",
      havingRelatedGuides: false,
      havingRelatedTopics: false,
      havingStrategiesForChange: true,
      RelatedGuides: [],
      RelatedTopics: []
    };
  },

  computed: {
    ...mapGetters("companion", ["getTopicById"]),
    wheelListener() {
      if (window.innerWidth >= 768) {
        return {
          wheel: this.handleWheel
        };
      } else {
        return {};
      }
    }
  },

  async mounted() {
    this.$watch(
      "$route.params.topicId",
      async () => {
        try {
          this.dailyStrategyLoading = true;
          const topicId = this.$route.params.topicId;
          let strategyObject = this.getTopicById(topicId);

          if (Object.keys(strategyObject).length === 0) {
            strategyObject = await this.fetchTopic({
              topicId: topicId
            });
          }

          this.topicData = strategyObject.data;
          this.strategyHeroImage = strategyObject.data.HeroImage;
          this.backgroundColor = "#" + strategyObject.data.BackgroundColor;
          this.RelatedGuides = strategyObject.data.Guides;
          this.RelatedTopics = strategyObject.data.Strategies;
          this.havingRelatedGuides = this.RelatedGuides.length > 0;
          this.havingRelatedTopics = this.RelatedTopics.length > 0;
          this.documentUrl = this.topicData.DocumentUrl;
          this.havingDocumentUrl = this.documentUrl.length > 0;

          this.dailyStrategyLoading = false;
        } catch (e) {
          this.dailyStrategyLoading = false;
          this.snackBar({
            duration: 5000,
            type: "is-danger",
            message: e.message
          });
        }
      },
      { immediate: true }
    );
  },

  methods: {
    ...mapActions("companion", ["fetchTopic"]),
    ...mapActions(["snackBar"]),

    goBack() {
      window.history.back();
    },

    getStrategyRedirectUrl(strategyId) {
      return `/plan/strategy/${strategyId}`;
    },

    getGuideRedirectUrl(guideId) {
      return `/plan/guide/${guideId}`;
    },

    redirectToDocument() {
      if (this.documentUrl) {
        window.open(this.documentUrl, "_blank");
      } else {
        this.snackBar({
          duration: 5000,
          type: "is-warning",
          message: "Document URL not available."
        });
      }
    },

    focusTasksContainer() {
      const slider = document.querySelector(".guide-card-container");
      slider.focus();
    },
    handleWheel(event) {
      const deltaY = event.deltaY;
      const absDeltaY = Math.abs(deltaY);
      const isExternalMouse = absDeltaY > 2;

      if (isExternalMouse) {
        const scrollContainer = document.querySelector(".guide-card-container");
        event.preventDefault();

        const scrollSpeed = 10;
        const newScrollLeft = scrollContainer.scrollLeft + deltaY * scrollSpeed;
        if (
          newScrollLeft > -10 &&
          newScrollLeft <=
            scrollContainer.scrollWidth - scrollContainer.clientWidth + 10
        ) {
          scrollContainer.scrollLeft = newScrollLeft;
        } else if (newScrollLeft < 0) {
          scrollContainer.scrollLeft = 0;
        } else if (
          newScrollLeft >
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          scrollContainer.scrollLeft =
            scrollContainer.scrollWidth - scrollContainer.clientWidth;
        }
      }
    }
  }
};
</script>

<style scoped>
#companion-topic-main .companion-topic-card {
  width: 70%;
  margin: auto;

  .companion-topic-content-wrapper {
    background-color: white;
    border: 1px solid #d9dbe0;
    border-radius: 12px 12px 0px 0px;
    padding: 24px 24px 24px 24px;
    gap: 16px;
    left: 0;

    .companion-topic-content {
      .companion-action-menu {
        padding-bottom: 20px;
      }

      .show-topic-details {
        .green-card {
          max-height: 220px;
          border-radius: 16px;
          .cover-art {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .cover-art img {
            max-height: 220px;
            padding: 20px;
          }
        }

        .topic-details-card {
          padding: 28px 16px 0px 0px;

          .topic-title {
            color: #5a5c60;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.25px;
          }

          .topic-number-title {
            color: #1b1d20;
            font-size: 24px;
            font-weight: 500;
            line-height: 30px;
            letter-spacing: 0.18px;
            padding-top: 9px;
          }

          .topic-info-title {
            display: flex;
            gap: 4px;
            align-items: center;

            color: #5a5c60;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            padding: 9px 0px 0px 0px;
          }

          .topic-part-summary {
            padding: 24px 0px 0px 0px;
            .avenir-medium {
              color: #1b1d20;
              font-size: 16px;
              font-weight: 400;
              line-height: 24px;
              letter-spacing: 0.25px;
              padding-bottom: 8px;
            }

            p {
              color: #5a5c60;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              letter-spacing: 0.25px;
              padding-bottom: 20px;
            }
          }
        }
      }
    }
  }

  .view-program-documents {
    background: #fbfbfb;
    .button-wrapper {
      display: flex;
      justify-content: center;
      padding-top: 24px;
      .blue-button {
        background-color: #2972f0;
        border-radius: 6px;
        border: none;
        color: white;
        padding: 0px 36px;
        &:hover {
          cursor: pointer;
        }
      }

      .doc-button-text {
        display: flex;
        width: 120px;
        padding: 4px 8px;
        justify-content: center;
        align-items: center;
        gap: 8px;

        span {
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
        }
        WtSvgIcon {
          margin-top: 7px;
        }
      }
    }
  }

  .companion-related-guides {
    padding: 32px 24px 0px 24px;
    background-color: #fbfbfb;
    margin: auto;

    .custom-padding {
      padding: 0px !important;

      .category-title {
        font-family: Manrope;
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0.15px;
        color: #1b1d20;
        margin-bottom: 16px !important;
      }
      .guide-card-container {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;
        gap: 10px !important;

        .guide-card {
          margin: 0rem !important;
        }
      }
      .guide-card-container::-webkit-scrollbar {
        display: none;
      }
      .guide-card-container:focus {
        outline: none;
      }
    }
  }

  .companion-guide-chapters-wrapper {
    margin: auto;
    background: #fbfbfb;

    .guide-chapters {
      padding: 0px 24px;

      .chapters-title {
        color: #1b1d20;
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0.15px;
        padding-bottom: 6px;
      }

      .chapters-list {
        .right-arrow-card {
          padding-top: 10px;
        }
      }
    }
  }

  .companion-related-strategy {
    padding: 28px 24px 32px 24px;
    background-color: #fbfbfb;
    margin: auto;
    border-radius: 0px 0px 16px 16px;

    .category-title {
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.15px;
      color: #1b1d20;
      margin-bottom: 16px !important;
    }

    .strategy-list {
      .right-arrow-card {
        padding-top: 10px;
      }
    }
  }
}

@media (max-width: 768px) {
  .companion-topic-card {
    min-width: 100%;
  }
}

@media (max-width: 480px) {
  .companion-topic-card {
    .companion-guide-chapters-wrapper {
      .chapters-title {
        padding-bottom: 10px;
      }
      .guide-chapters {
        padding: 0px;
        .chapters-list {
          .right-arrow-card {
            padding-top: 8px;
          }
        }
      }
    }

    .companion-guide-content-wrapper {
      width: 100%;
      padding: 20px 20px 20px 20px;
      .companion-guide-content {
        .show-guide-details {
          .guide-details-card {
            padding: 28px 1px 0px 1px;

            .guide-part-summary {
              .avenir-medium,
              p {
                padding-right: 40px;
              }
            }
          }
        }
      }
    }
    .companion-related-guides {
      .guide-card-container {
        flex-direction: column;
      }
    }
  }
}
</style>
